import {
  TBulkEvent,
  TDefectiveReleatedEvent,
  TEventAboutDTO,
  TEventActionType,
  TEventBctxDetails,
  TEventCommonDetails,
  TEventLocation,
  TEventStationDetails,
  TEventWhat,
  TDefectiveFromServer,
  TSingleDefectiveEvent,
  TSingleCountEvent,
  TLastEventResult,
  TValidAndInvalidDefectivesInfo,
  TServerDefectivesDB,
  TForwardBulkEvent,
  TSingleReworkedEventFromDefectives,
  TDefectiveInfoWithLinkedVId,
  TBctxItemWithoutSize,
  TBctxChangeEvent,
  TMemberAdditionEvent,
  TBulkCountEvent,
  TUserActualsDB,
  TSingleRejectedEventFromDefectives,
  TBackgroundEventsSyncingDB,
  TBulkEventWithoutStatus,
  TBctxChangeEventWithoutStatus,
  TBulkEventBackgroundData,
  TMemberAdditionEventWithoutStatus,
  TMemberAdditionType,
  TMemberAdditionInfo,
  TAuditDTOModel,
  TRoamingQcEventWithoutStatus,
  TSingleEvent,
  ColourGrades,
  DefectTypes,
  TRoamingQcEvent,
  TPastDaysDefective,
  TPastDaysDefectivesInfo,
  TBctxChangeEventSizeInfo,
  TValidAndInvalidPerPieceEventsInfo,
  TPerPieceDefectiveInfoWithLinkedVId,
  TGenericEvent,
  TBundleQcCompleteSingleEvent,
  TBundleQcMissingSingleEvent,
  TSingleDefectiveEventWithoutStatus,
  TServerDefectivesDataUndo,
  TSampleModel,
  TAqlEvent,
  TSingleAuditDetail,
  TAqlEventWithoutStatus,
  TSupportedLanguages,
  TBctxItem,
  TPastDaysBackgroundEventsSyncInfo,
  TActionItemType,
  TActivityLogEvent,
  TPastDaySyncedEventsDB,
} from '@monorepo/types';
import { BCTXComputationHelper } from './bctx-computation-helper';
import { v4 as uuidv4 } from 'uuid';
import * as _ from 'lodash';
import { StackUtil } from './stack-util';
import { BctxViz } from 'libs/types/src/lib/input-app/pre-settings.types';
import * as moment from 'moment';
import produce from 'immer';
import { TBucketId } from 'libs/services/src/lib/capacitor/bucket-storage.types';
import { LOCAL_STORAGE_UTILS } from '../localStorage.utils';
import { LocalisationUtils } from '../localisation.utils';
export const EventUtil = {
  getLastEventRemaining<T>(events: TGenericEvent<T>[]) {
    const stack = new StackUtil<TGenericEvent<T>>();
    let forceStopEvent: TGenericEvent<T> | undefined;
    events.forEach((defective) => {
      stack.push(defective);
      while (!stack.isEmpty() && !forceStopEvent) {
        const peek = stack.peek();
        if (
          peek.actionType === 'UNDO_CHECK_IN' ||
          peek.actionType === 'UNDO_FTT' ||
          peek.actionType === 'UNDO_REJECTED' ||
          peek.actionType === 'UNDO_DEFECTIVE' ||
          peek.actionType === 'UNDO_REJECTED_FROM_DEFECTIVE' ||
          peek.actionType === 'UNDO_REWORKED_FROM_DEFECTIVE'
        ) {
          if (stack.size() > 1) {
            stack.pop();
            stack.pop();
          } else {
            forceStopEvent = peek;
          }
        } else break;
      }
    });
    if (forceStopEvent) return forceStopEvent;
    return stack.isEmpty() ? null : stack.peek();
  },

  hasAnyPendingEvents(userDB: TUserActualsDB, bgDB: TBackgroundEventsSyncingDB) {
    if (
      bgDB.persistanceCache.pastDaysList.length > 0 ||
      userDB.dailyCache.events.list.length !== bgDB.dailyCache.events.list.length
    )
      return true;
    else return this.hasAnyYetToBeSyncedEventsInBgDB(bgDB.dailyCache.events.list);
  },

  hasAnyYetToBeSyncedEventsInBgDB(events: TBulkEventBackgroundData[]) {
    return this.getLastSyncedIndexInBgDB(events) === events.length - 1 ? false : true;
    //Removed last event look-up approach, because to be on safe side if some how sequence of 'YET_TO_BE_SYNCED' is not contingous
    //due to wrong generating of event dto
    // if (events.length === 0) return false;
    // return events[events.length - 1].metadata.bulkEventStatus === 'YET_TO_BE_SYNCED';
  },

  getLastSyncedIndexInBgDB(events: TBulkEventBackgroundData[]) {
    for (let index = 0; index < events.length; index++) {
      if (events[index].backgroundMetadata.bulkEventStatus === 'YET_TO_BE_SYNCED') return index - 1;
    }
    return events.length - 1;
    //Removed binary-serach approach, because to be on safe side if some how sequence of 'YET_TO_BE_SYNCED' is not contingous
    //due to wrong generating of event dto
    // if (events.length === 0) return -1;
    // let l = 0,
    //   r = events.length - 1;
    // while (l < r) {
    //   let mid = Math.floor((l + r) / 2);
    //   if (events[mid].metadata.bulkEventStatus === 'YET_TO_BE_SYNCED') r = mid;
    //   else l = mid + 1;
    // }
    // if (events[r].metadata.bulkEventStatus === 'YET_TO_BE_SYNCED') return r - 1;
    // else return r;
  },

  hasAnyYetToBeSyncedEvents(events: TBulkEvent[]) {
    return this.getLastSyncedIndex(events) === events.length - 1 ? false : true;
    //Removed last event look-up approach, because to be on safe side if some how sequence of 'YET_TO_BE_SYNCED' is not contingous
    //due to wrong generating of event dto
    // if (events.length === 0) return false;
    // return events[events.length - 1].metadata.bulkEventStatus === 'YET_TO_BE_SYNCED';
  },

  getLastSyncedIndex(events: TBulkEvent[]) {
    for (let index = 0; index < events.length; index++) {
      if (events[index].backgroundMetadata.bulkEventStatus === 'YET_TO_BE_SYNCED') return index - 1;
    }
    return events.length - 1;
    //Removed binary-serach approach, because to be on safe side if some how sequence of 'YET_TO_BE_SYNCED' is not contingous
    //due to wrong generating of event dto
    // if (events.length === 0) return -1;
    // let l = 0,
    //   r = events.length - 1;
    // while (l < r) {
    //   let mid = Math.floor((l + r) / 2);
    //   if (events[mid].metadata.bulkEventStatus === 'YET_TO_BE_SYNCED') r = mid;
    //   else l = mid + 1;
    // }
    // if (events[r].metadata.bulkEventStatus === 'YET_TO_BE_SYNCED') return r - 1;
    // else return r;
  },

  getWhenObjectOfSaveEvent: (singleEvent: TBulkEvent['events'][number]) => {
    return {
      dt:
        singleEvent.type === 'UNDO_EVENT' ? singleEvent.undoMetadata.forwardEventTime : singleEvent.eventInfo.eventTime,
      tz: 'Asia/Colombo',
      os: new Date(singleEvent.eventInfo.eventTime).getTimezoneOffset(),
      src_dt: singleEvent.type === 'UNDO_EVENT' ? singleEvent.eventInfo.eventTime : undefined,
    };
  },

  getIndexByVId(event: TBulkEvent, v_id: string) {
    return event.events.findIndex((singleEvent) => singleEvent.eventInfo.v_id === v_id);
  },

  getWhatObjectOfNonCountEvent(
    event:
      | TBctxChangeEvent['events'][0]
      | TMemberAdditionEvent['events'][0]
      | TRoamingQcEvent['events'][0]
      | TBundleQcCompleteSingleEvent
      | TBundleQcMissingSingleEvent
      | TAqlEvent['events'][0],
    bctxViz: BctxViz[],
    deviceId: string,
  ): TEventWhat {
    switch (event.type) {
      case 'ROAMING_QC_EVENT': {
        const auditDetails = event.eventInfo.auditDetails;
        return {
          ac: auditDetails.samples.map((sample, index) => {
            return {
              size: {
                name: auditDetails.size,
                a_ctx: 1,
              },
              row_id: index + 1,
              row_pass: sample.status === 'pass' ? 1 : 0,
              row_fail: sample.status === 'fail' ? 1 : 0,
              status: sample.status,
              issues: sample.defects,
              row_qty: 1,
              row_sample: 1,
            };
          }),
          ty: 'category',
          nm: 'rqc_audit',
          vl: 1,
          cv: 1,
          ad: deviceId,
        };
      }
      case 'AQL_EVENT': {
        const auditDetails = event.eventInfo.auditDetails;
        return {
          ac: auditDetails.rows.map((row) => {
            return {
              size: {
                name: row.size,
                a_ctx: 1,
              },
              row_pass: row.row_pass,
              row_fail: row.row_fail,
              row_id: row.row_id,
              row_sample: row.row_sample,
              row_qty: row.row_qty,
              issues: row.issues.map((issue) => issue),
              pass_measurement: row.pass_measurement.map((issue) => issue),
              fail_measurement: row.fail_measurement.map((issue) => issue),
            };
          }),
          aql_level_details: {
            aql_level_buyer: auditDetails.aql_level.buyer,
            aql_level: auditDetails.aql_level.aql_level,
            aql_level_lot_range_start: auditDetails.aql_level.lot_range_start.toString(),
            aql_level_lot_range_end: auditDetails.aql_level.lot_range_end.toString(),
            aql_level_sample: auditDetails.aql_level.sample.toString(),
            aql_level_pass_qty: auditDetails.aql_level.pass_qty.toString(),
            aql_level_fail_qty: auditDetails.aql_level.fail_qty.toString(),
          },
          ty: 'category',
          nm: 'audit',
          vl: 1,
          cv: auditDetails.metaData.action_taken === 'undo_audit' ? -1 : 1,
          ad: deviceId,
        };
      }
      case 'BCTX_CHANGE_EVENT': {
        return {
          ac: [
            {
              action: 'old',
              actual: BCTXComputationHelper.getBctxContexts(
                BCTXComputationHelper.includeSizeAndOrderBctxItem(
                  event.eventInfo.oldBctxItemListWithoutSize,
                  bctxViz,
                  event.eventInfo.oldSize,
                ),
                bctxViz,
              ),
            },
            {
              action: 'new',
              actual: BCTXComputationHelper.getBctxContexts(
                BCTXComputationHelper.includeSizeAndOrderBctxItem(
                  event.eventInfo.newBctxItemListWithoutSize,
                  bctxViz,
                  event.eventInfo.newSize,
                ),
                bctxViz,
              ),
            },
          ],
          ty: 'change_e',
          nm: 'bctx_change',
          vl: 1,
          cv: 1,
          ad: deviceId,
        };
      }
      case 'BUNDLE_QC_COMPLETE_EVENT':
        return {
          ac: [],
          ty: 'time',
          nm: 'complete',
          vl: event.eventInfo.bundleQty,
          cv: 1,
          rf: null,
          dv: false,
          ad: deviceId,
        };
      case 'BUNDLE_QC_MISSING_EVENT':
        return {
          ac: [],
          ty: 'category',
          nm: 'missing',
          vl: event.eventInfo.missingQty,
          cv: 1,
          rf: null,
          dv: false,
          ad: deviceId,
        };
      case 'MEMBER_ADDITION_EVENT':
        return {
          ac: event.eventInfo.memberAdditionInfo.list.reduce((acc, curr) => {
            acc[curr.type] = curr.count;
            return acc;
          }, {} as Record<TMemberAdditionType, number>),
          ty: 'category',
          nm: event.eventInfo.memberAdditionInfo.eventType,
          vl: 1,
          cv: 1,
          ad: deviceId,
        };
    }
  },

  getWhatObjectOfSaveEvent: (event: TBulkCountEvent['events'][0], deviceId: string): TEventWhat => {
    const size = event.eventInfo.bctxDetails.size;
    const count = event.eventInfo.bctxDetails.count;
    switch (event.actionType) {
      case 'CHECK_IN':
      case 'UNDO_CHECK_IN':
        return {
          ac: [
            {
              size: {
                name: size,
                a_ctx: 1,
              },
            },
          ],
          rf: null,
          ty: 'category',
          nm: 'checkin',
          vl: count,
          cv: event.actionType === 'CHECK_IN' ? 1 : -1,
          dv: false,
          ad: deviceId,
        };
      case 'FTT':
      case 'UNDO_FTT':
        return {
          ac: [
            {
              size: {
                name: size,
                a_ctx: 1,
              },
            },
          ],
          rf: null,
          ty: 'category',
          nm: 'ftt',
          vl: count,
          cv: event.actionType === 'FTT' ? 1 : -1,
          dv: false,
          ad: deviceId,
        };
      case 'REJECTED':
      case 'UNDO_REJECTED':
        return {
          ac: event.rejectedInfo.reasons.map((rejectReason) => {
            return {
              issues: rejectReason,
              size: {
                name: size,
                a_ctx: 1,
              },
            };
          }),
          rf: null,
          ty: 'category',
          nm: 'reject',
          vl: count,
          cv: event.actionType === 'REJECTED' ? 1 : -1,
          dv: false,
          defective_image_id: event.imageId ? event.imageId : undefined,
          ad: deviceId,
        };
      case 'DEFECTIVE':
      case 'UNDO_DEFECTIVE':
        return {
          ac: event.defectivesInfo.defectives.map((defective) => {
            return {
              ...defective,
              size: {
                name: size,
                a_ctx: 1,
              },
            };
          }),
          rf: null,
          ty: 'category',
          nm: event.subType === 'DEFECTIVE' || event.subType === 'UNDO_DEFECTIVE' ? 'defectives' : 'defectives_r',
          vl: count,
          cv: event.actionType === 'DEFECTIVE' ? 1 : -1,
          dv: false,
          defective_image_id: event.imageId ? event.imageId : undefined,
          ad: deviceId,
        };
      case 'REWORKED_FROM_DEFECTIVE':
      case 'UNDO_REWORKED_FROM_DEFECTIVE':
        return {
          ac: event.defectivesInfo.defectives.map((defective) => {
            return {
              ...defective,
              size: {
                name: size,
                a_ctx: 1,
              },
            };
          }),
          rf: null,
          ty: 'category',
          nm: 'reworked',
          vl: count,
          cv: event.actionType === 'REWORKED_FROM_DEFECTIVE' ? 1 : -1,
          dv: false,
          defective_image_id: event.imageId ? event.imageId : undefined,
          ad: deviceId,
        };
      case 'REJECTED_FROM_DEFECTIVE':
      case 'UNDO_REJECTED_FROM_DEFECTIVE':
        return {
          ac: event.rejectedInfo.reasons.map((rejectReason) => {
            return {
              issues: rejectReason,
              size: {
                name: size,
                a_ctx: 1,
              },
            };
          }),
          rf: null,
          ty: 'category',
          nm: 'reject_r',
          vl: count,
          cv: event.actionType === 'REJECTED_FROM_DEFECTIVE' ? 1 : -1,
          dv: false,
          defective_image_id: event.imageId ? event.imageId : undefined,
          ad: deviceId,
        };
    }
  },

  getAuditColour(eventDTO: Omit<TAuditDTOModel, 'colour'>): string {
    /*
        * In here grading logic would be as follows
        - Green -> All samples are good
        - yellow -> 1 minor issue found
        - Red -> More than one minor issue or any major / Critical defect found
     */

    let colour = '';
    try {
      const samples = eventDTO.samples;
      const failedSamples = samples.filter((sample) => sample.status === 'fail');
      if (failedSamples.length === 0) {
        colour = ColourGrades.GREEN;
      } else if (failedSamples.length > 1) {
        colour = ColourGrades.RED;
      } else {
        let minorIssueCount = 0;
        let majorIssueCount = 0;
        for (let i = 0; i < failedSamples.length; i++) {
          if (minorIssueCount > 1 || majorIssueCount > 0) {
            break;
          }
          const selectedSample = failedSamples[i].defects;
          for (let j = 0; j < selectedSample.length; j++) {
            if (selectedSample[j].category.toLowerCase() === DefectTypes.MINOR.toLowerCase()) {
              minorIssueCount += 1;
            } else {
              majorIssueCount += 1;
            }
          }
        }

        colour = majorIssueCount > 0 || minorIssueCount > 1 ? ColourGrades.RED : ColourGrades.YELLOW;
      }
    } catch (e) {}
    return colour;
  },

  getAuditColourForDefectWithNoCategory(samples: TSampleModel[]): string {
    const failedSamples = samples.filter((sample) => sample.status === 'fail');
    if (failedSamples.length === 0) return ColourGrades.GREEN;
    if (failedSamples.length > 1) return ColourGrades.RED;

    if (failedSamples[0].defects.length === 1) return ColourGrades.YELLOW;
    return ColourGrades.RED;
  },

  getAboutObject(stationDetails: TEventStationDetails, singleEvent: TSingleEvent, bctxViz: BctxViz[]): TEventAboutDTO {
    const { subject, shift } = stationDetails;
    // ctx --> New Bctx (Child)  |  wip_override_ctx --> Old Bctx (Parent)
    let ctx =
      singleEvent.type === 'AQL_EVENT'
        ? BCTXComputationHelper.includeSizeAndOrderBctxItem(
            singleEvent.eventInfo.auditDetails.bctxItemListWithoutSize,
            bctxViz,
          )
        : singleEvent.type === 'FORWARD_EVENT' ||
          singleEvent.type === 'UNDO_EVENT' ||
          singleEvent.type === 'BUNDLE_QC_COMPLETE_EVENT' ||
          singleEvent.type === 'BUNDLE_QC_MISSING_EVENT' ||
          singleEvent.type === 'ROAMING_QC_EVENT'
        ? BCTXComputationHelper.includeSizeAndOrderBctxItem(
            singleEvent.type === 'ROAMING_QC_EVENT'
              ? singleEvent.eventInfo.auditDetails.bctxItemListWithoutSize
              : singleEvent.type === 'FORWARD_EVENT'
              ? singleEvent.eventInfo.bctxDetails.newBctxDetails
                ? singleEvent.eventInfo.bctxDetails.newBctxDetails.businessContextDetailsWithoutSize // New Bctx
                : singleEvent.eventInfo.bctxDetails.businessContextDetailsWithoutSize
              : singleEvent.eventInfo.bctxDetails.businessContextDetailsWithoutSize,
            bctxViz,
            singleEvent.type === 'ROAMING_QC_EVENT'
              ? singleEvent.eventInfo.auditDetails.size
              : singleEvent.eventInfo.bctxDetails.size,
          )
        : BCTXComputationHelper.getBctxContexts(
            BCTXComputationHelper.includeSizeAndOrderBctxItem(
              singleEvent.eventInfo.newBctxItemListWithoutSize,
              bctxViz,
              singleEvent.eventInfo.newSize,
            ),
            bctxViz,
          );
    console.log({ ctx });
    let wip_override_ctx: TBctxItem[] | undefined;
    if (singleEvent.type === 'FORWARD_EVENT' && singleEvent.eventInfo.bctxDetails.newBctxDetails) {
      const { businessContextDetailsWithoutSize, newBctxDetails } = singleEvent.eventInfo.bctxDetails;
      wip_override_ctx = businessContextDetailsWithoutSize.reduce((acc, curr) => {
        const item = newBctxDetails.groupedHeaderInfo!.find((item) => item.key === curr.k);
        if (item) acc.push(curr);
        return acc;
      }, [] as TBctxItem[]);
    } else if (singleEvent.type === 'UNDO_EVENT' && singleEvent.eventInfo.bctxDetails.newBctxDetails) {
      wip_override_ctx = singleEvent.eventInfo.bctxDetails.businessContextDetailsWithoutSize.filter(
        (ele) => ele.k === 'po' || ele.k === 'order_ref',
      );
      ctx = produce(ctx, (draft) => {
        const newPo = singleEvent.eventInfo.bctxDetails.newBctxDetails?.businessContextDetailsWithoutSize.find(
          (ele) => ele.k === 'po',
        );
        const newOrderRef = singleEvent.eventInfo.bctxDetails.newBctxDetails?.businessContextDetailsWithoutSize.find(
          (ele) => ele.k === 'order_ref',
        );

        draft.forEach((ele) => {
          if (newPo && ele.k === 'po') ele.v = newPo.v;
          if (newOrderRef && ele.k === 'order_ref') ele.v = newOrderRef.v;
        });
      });
    }
    let defectAux;
    if (
      singleEvent.actionType === 'DEFECTIVE' ||
      singleEvent.actionType === 'REJECTED_FROM_DEFECTIVE' ||
      singleEvent.actionType === 'REWORKED_FROM_DEFECTIVE' ||
      singleEvent.actionType === 'UNDO_DEFECTIVE' ||
      singleEvent.actionType === 'UNDO_REJECTED_FROM_DEFECTIVE' ||
      singleEvent.actionType === 'UNDO_REWORKED_FROM_DEFECTIVE'
    ) {
      defectAux = {
        gId: singleEvent.defectivesInfo.id,
        rnd: singleEvent.defectivesInfo.round,
        snm:
          (singleEvent.defectivesInfo.defectives[0] &&
            singleEvent.defectivesInfo.defectives[0].silhouette &&
            singleEvent.defectivesInfo.defectives[0].silhouette.shillohutte_id) ||
          null,
      };
    }
    const num: TEventAboutDTO['ecx']['num'] = {};
    let search_id: null | string = null;
    let display_tag_id: null | string = null;
    ctx.forEach(({ k, v }) => {
      if (k === 'search_id') {
        search_id = v;
      } else if (k === 'display_piece_tag') display_tag_id = v;
    });
    const tag: TEventAboutDTO['ecx']['tag'] = {
      shift: shift ? shift.id + '_D_' + BCTXComputationHelper.dashFormateDate() : '',
      shift_dn: shift ? shift.name : '',
      search_id: search_id,
      search_dn: display_tag_id,
      src_ids: {
        search_id: search_id,
        search_dn: display_tag_id,
        ...(singleEvent.type === 'BUNDLE_QC_COMPLETE_EVENT' || singleEvent.type === 'BUNDLE_QC_MISSING_EVENT'
          ? { bundleQty: singleEvent.eventInfo.bundleQty }
          : {}),
      },
    };
    if (singleEvent.type === 'ROAMING_QC_EVENT') {
      const auditDetails = singleEvent.eventInfo.auditDetails;
      num.sample_qty = auditDetails.samples.length;
      num.pass = auditDetails.samples.filter((item) => item.status === 'pass').length;
      const failedSamples = auditDetails.samples.filter((item) => item.status === 'fail');
      num.fail = failedSamples.length;
      num.defects = failedSamples.map((item) => item.defects).length;

      tag.audit_id = singleEvent.eventInfo.v_id;
      tag.audit_cycle = auditDetails.round;
      tag.audit_cycle_id = auditDetails.cycle_id;
      tag.status = auditDetails.colour;
      tag.operator_id = auditDetails.operator;
      tag.source_name = 'user';
      tag.operation = auditDetails.operation;
      tag.record_category = 'complete';
    }

    if (singleEvent.type === 'AQL_EVENT') {
      const auditDetails = singleEvent.eventInfo.auditDetails;
      num.sample_qty = auditDetails.summary.sample_qty;
      num.pass = auditDetails.summary.pass;
      num.fail = auditDetails.summary.fail;
      num.qty = auditDetails.summary.qty;
      num.rqty = auditDetails.summary.qty;
      num.bqty = auditDetails.summary.qty;
      num.wqty = auditDetails.summary.qty;

      tag.audit_cycle = auditDetails.metaData.auditCycle;
      tag.audit_disName = auditDetails.metaData.auditDisplayName;
      tag.audit_id = auditDetails.metaData.auditId;
      tag.re_audit_id = auditDetails.metaData.reAuditId;
      tag.status = auditDetails.metaData.status;
    }

    return {
      sub: subject ? subject.subject : '',
      aux: {
        hsk: subject ? subject.hsk : '',
        dnm: subject ? subject.dis_name : '',
        dnr: subject ? subject.gatev : '',
        gid: defectAux?.gId,
        rnd: defectAux?.rnd,
        snm: defectAux?.snm,
        smv: singleEvent.actionType === 'ROAMING_QC_EVENT' ? 0 : undefined,
      },
      ecx: {
        num: num,
        tag: tag,
      },
      snm: subject ? subject.dis_name : '',
      dnrk: subject ? subject.gatek : '',
      ctx,
      wip_override_ctx,
    };
  },

  getRelatedActionTypesForUndo(actionType: TActionItemType): TEventActionType[] {
    switch (actionType) {
      case 'FTT':
        return ['UNDO_FTT', 'FTT'];
      case 'CHECK_IN':
        return ['UNDO_CHECK_IN', 'CHECK_IN'];
      case 'DEFECTIVE':
        return ['UNDO_DEFECTIVE', 'DEFECTIVE'];
      case 'REJECTED':
        return ['UNDO_REJECTED', 'REJECTED', 'UNDO_REJECTED_FROM_DEFECTIVE', 'REJECTED_FROM_DEFECTIVE'];
      case 'REWORKED_FROM_DEFECTIVE':
        return ['UNDO_REWORKED_FROM_DEFECTIVE', 'REWORKED_FROM_DEFECTIVE'];
    }
  },

  getActionTypeForBulkEvent(bulkEvent: TBulkEvent) {
    return bulkEvent.events[0].actionType;
  },

  getBulkEventFromSingleDefectiveEvent(bulkEvents: TBulkEvent[], singleEvent: TSingleDefectiveEvent) {
    return bulkEvents.filter(
      (bulkEvent) => bulkEvent.events.length === 1 && bulkEvent.events[0].eventInfo.v_id === singleEvent.eventInfo.v_id,
    )[0];
  },

  getLastForwardDefectiveEvent(
    bulkEvents: TBulkEvent[],
    subjectId: string,
    shiftId: string,
    undoLimit: number,
    bctxKey: string | null,
  ): TLastEventResult {
    const gIdToDefectivesInfo = this.getValidAndInvalidDefectivesInfo(shiftId, subjectId, bulkEvents, bctxKey);
    const location = bctxKey ? 'WITH_IN_BCTX' : 'ACROSS_BCTX';
    const filteredEvents = bulkEvents.filter((bulkEvent) => {
      return (
        this.hasEventHappenedInStationDetails(bulkEvent, subjectId, shiftId) &&
        (bulkEvent.type === 'FORWARD_BULK_EVENT' || bulkEvent.type === 'UNDO_BULK_EVENT') &&
        location === bulkEvent.metadata.location &&
        this.getRelatedActionTypesForUndo('DEFECTIVE').some(
          (actionType) => actionType === this.getActionTypeForBulkEvent(bulkEvent),
        ) &&
        (!bctxKey || bulkEvent.events[0].eventInfo.bctxDetails.bctxKey === bctxKey)
      );
    });
    let undoEventsCount = 0;
    let forwardEventsCount = 0;
    const undoGroupIdSet = new Set<string>();
    for (let index = filteredEvents.length - 1; index >= 0; index--) {
      const bulkEvent = filteredEvents[index];
      const singleEvent = bulkEvent.events[0] as TSingleDefectiveEvent;
      const gId = singleEvent.defectivesInfo.id;
      if (bulkEvent.type === 'UNDO_BULK_EVENT') {
        undoEventsCount++;
        if (undoEventsCount >= undoLimit) {
          return {
            status: 'FAILURE',
            error: 'LIMIT_REACHED',
          };
        }
        undoGroupIdSet.add(bulkEvent.undoMetadata.forwardEventGroupId);
      } else if (undoGroupIdSet.has(bulkEvent.metadata.groupId)) {
        forwardEventsCount++;
      } else if (forwardEventsCount === undoEventsCount) {
        if (
          gIdToDefectivesInfo[gId].eventList.length === 1 &&
          (gIdToDefectivesInfo[gId].hasAnyServerErrorEvent || gIdToDefectivesInfo[gId].failedEventVIds.size === 1)
        ) {
          continue;
        }
        if (!gIdToDefectivesInfo[gId].hasAnyServerErrorEvent && gIdToDefectivesInfo[gId].failedEventVIds.size === 0) {
          const stack = new StackUtil<TDefectiveReleatedEvent>();
          gIdToDefectivesInfo[gId].eventList.forEach((event) => {
            stack.push(event);
            while (!stack.isEmpty()) {
              const peekItem = stack.peek();
              if (
                peekItem.actionType === 'UNDO_DEFECTIVE' ||
                peekItem.actionType === 'UNDO_REJECTED_FROM_DEFECTIVE' ||
                peekItem.actionType === 'UNDO_REWORKED_FROM_DEFECTIVE'
              ) {
                stack.pop();
                stack.pop();
              } else break;
            }
          });
          if (!stack.isEmpty()) {
            const peekItem = stack.peek();
            if (peekItem.actionType === 'DEFECTIVE') {
              if (peekItem.eventInfo.v_id === singleEvent.eventInfo.v_id) {
                return {
                  status: 'SUCCESS',
                  event: produce(
                    this.getBulkEventFromSingleDefectiveEvent(bulkEvents, peekItem) as TForwardBulkEvent,
                    (draft) => {
                      draft.events[0].eventInfo.v_id =
                        gIdToDefectivesInfo[gId].futureValidEventList[
                          gIdToDefectivesInfo[gId].futureValidEventList.length - 1
                        ].eventInfo.v_id;
                    },
                  ),
                };
              } else {
                return {
                  status: 'FAILURE',
                  error: 'EVENTS_ADDED_FROM_OTHER_LOCATION',
                };
              }
            } else {
              return {
                status: 'FAILURE',
                error: peekItem.actionType === 'REWORKED_FROM_DEFECTIVE' ? 'DEFECT_REWORKED' : 'DEFECT_REJECTED',
              };
            }
          }
        } else {
          return {
            status: 'FAILURE',
            error: gIdToDefectivesInfo[gId].hasAnyServerErrorEvent ? 'SERVER_ERROR' : 'HISTORY_CHANGED',
          };
        }
      }
    }
    return {
      status: 'FAILURE',
      error: 'NO_EVENTS_ADDED',
    };
  },

  getLastForwardEventWithoutUndo(
    bulkEvents: TBulkEvent[],
    subjectId: string,
    shiftId: string,
    actionType: 'FTT' | 'REJECTED' | 'REWORKED_FROM_DEFECTIVE' | 'CHECK_IN',
    undoLimit: number,
    bctxKey: string | null,
  ): TLastEventResult {
    const location = bctxKey ? 'WITH_IN_BCTX' : 'ACROSS_BCTX';
    const filteredEvents = bulkEvents.filter((bulkEvent) => {
      return (
        this.hasEventHappenedInStationDetails(bulkEvent, subjectId, shiftId) &&
        (bulkEvent.type === 'FORWARD_BULK_EVENT' || bulkEvent.type === 'UNDO_BULK_EVENT') &&
        this.getRelatedActionTypesForUndo(actionType).some((relatedUndoActionType) => {
          return relatedUndoActionType === this.getActionTypeForBulkEvent(bulkEvent);
        }) &&
        location === bulkEvent.metadata.location &&
        (!bctxKey || bulkEvent.events[0].eventInfo.bctxDetails.bctxKey === bctxKey)
      );
    });

    let undoEventsCount = 0;
    let forwardEventsCount = 0;
    const undoGroupIdSet = new Set<string>();
    for (let index = filteredEvents.length - 1; index >= 0 && undoEventsCount < undoLimit; index--) {
      const event = filteredEvents[index];
      const eventActionType = this.getActionTypeForBulkEvent(filteredEvents[index]);
      if (event.type === 'FORWARD_BULK_EVENT') {
        if (
          event.backgroundMetadata.bulkEventStatus === 'SYNCED' ||
          event.backgroundMetadata.bulkEventStatus === 'YET_TO_BE_SYNCED' ||
          undoGroupIdSet.has(event.metadata.groupId)
        ) {
          forwardEventsCount++;
          if (forwardEventsCount > undoEventsCount) {
            if (eventActionType === 'FTT' || eventActionType === 'CHECK_IN' || eventActionType === 'REJECTED') {
              return {
                status: 'SUCCESS',
                event: event,
              };
            } else {
              const gIdToDefectivesInfo = this.getValidAndInvalidDefectivesInfo(
                shiftId,
                subjectId,
                bulkEvents,
                bctxKey,
              );
              let hasAnyServerErrorEvent = false,
                hasAnyFutureFailedEvent = false;
              (event.events as (TSingleReworkedEventFromDefectives | TSingleRejectedEventFromDefectives)[]).forEach(
                (event) => {
                  const gId = event.defectivesInfo.id;
                  hasAnyServerErrorEvent = hasAnyServerErrorEvent || gIdToDefectivesInfo[gId].hasAnyServerErrorEvent;
                  hasAnyFutureFailedEvent =
                    hasAnyFutureFailedEvent || gIdToDefectivesInfo[gId].failedEventVIds.size > 0;
                },
              );
              if (hasAnyServerErrorEvent || hasAnyFutureFailedEvent) {
                return {
                  status: 'FAILURE',
                  error: hasAnyServerErrorEvent ? 'SERVER_ERROR' : 'HISTORY_CHANGED',
                };
              } else {
                return {
                  status: 'SUCCESS',
                  event: event,
                };
              }
            }
          }
        }
      } else if (event.type === 'UNDO_BULK_EVENT') {
        undoEventsCount++;
        undoGroupIdSet.add(event.undoMetadata.forwardEventGroupId);
      }
    }
    return {
      status: 'FAILURE',
      error: undoEventsCount === undoLimit ? 'LIMIT_REACHED' : 'NO_EVENTS_ADDED',
    };
  },

  getLastForwardPerPieceDefectiveEvent(
    bulkEvents: TBulkEvent[],
    subjectId: string,
    shiftId: string,
    undoLimit: number,
    serverDefectivesDataUndo: TServerDefectivesDataUndo,
  ): TLastEventResult {
    const bctxKeyToDefectivesInfo = this.getValidAndInvalidPerPieceEventsInfo(bulkEvents);
    const filteredEvents = bulkEvents.filter((bulkEvent) => {
      return (
        this.hasEventHappenedInStationDetails(bulkEvent, subjectId, shiftId) &&
        (bulkEvent.type === 'FORWARD_BULK_EVENT' || bulkEvent.type === 'UNDO_BULK_EVENT') &&
        this.getRelatedActionTypesForUndo('DEFECTIVE').some(
          (actionType) => actionType === this.getActionTypeForBulkEvent(bulkEvent),
        )
      );
    });
    let undoEventsCount = 0;
    let forwardEventsCount = 0;
    const undoGroupIdSet = new Set<string>();
    for (let index = filteredEvents.length - 1; index >= 0; index--) {
      const bulkEvent = filteredEvents[index];
      const singleEvent = bulkEvent.events[0] as TSingleDefectiveEvent;
      const gId = singleEvent.eventInfo.bctxDetails.bctxKey;
      if (bulkEvent.type === 'UNDO_BULK_EVENT') {
        undoEventsCount++;
        if (undoEventsCount >= undoLimit) {
          return {
            status: 'FAILURE',
            error: 'LIMIT_REACHED',
          };
        }
        undoGroupIdSet.add(bulkEvent.undoMetadata.forwardEventGroupId);
      } else if (undoGroupIdSet.has(bulkEvent.metadata.groupId)) {
        forwardEventsCount++;
      } else if (forwardEventsCount === undoEventsCount) {
        if (
          bulkEvent.events[0].eventBackgroundMetadata.status === 'SYNCED_WITH_SUCCESS' ||
          bulkEvent.events[0].eventBackgroundMetadata.status === 'YET_TO_BE_SYNCED'
        ) {
          if (
            !bctxKeyToDefectivesInfo[gId].hasAnyServerErrorEvent &&
            bctxKeyToDefectivesInfo[gId].failedEventVIds.size === 0
          ) {
            const stack = new StackUtil<TBulkCountEvent>();
            bctxKeyToDefectivesInfo[gId].eventList.forEach((event) => {
              stack.push(event);
              while (!stack.isEmpty()) {
                const peekItem = stack.peek();
                const peekItemActionType = peekItem.events[0].actionType;
                if (
                  peekItemActionType === 'UNDO_REJECTED' ||
                  peekItemActionType === 'UNDO_FTT' ||
                  peekItemActionType === 'UNDO_DEFECTIVE' ||
                  peekItemActionType === 'UNDO_REJECTED_FROM_DEFECTIVE' ||
                  peekItemActionType === 'UNDO_REWORKED_FROM_DEFECTIVE'
                ) {
                  stack.pop();
                  stack.pop();
                } else break;
              }
            });
            if (!stack.isEmpty()) {
              const peekItem = stack.peek();
              if (peekItem.events[0].actionType === 'DEFECTIVE') {
                // check if any event in server is available which have higher round value
                const lastEventTimeOfLocalEvents = peekItem.events[0].eventInfo.eventTime;
                if (
                  serverDefectivesDataUndo &&
                  serverDefectivesDataUndo.serverDefectives.length > 0 &&
                  serverDefectivesDataUndo.latestServerDefectivesSyncTime &&
                  serverDefectivesDataUndo.latestServerDefectivesSyncTime > lastEventTimeOfLocalEvents
                ) {
                  const hasHigherRoundDefectives = serverDefectivesDataUndo.serverDefectives.find(
                    (event) =>
                      event.eventInfo.bctxDetails.bctxKey === gId &&
                      event.defectivesInfo.round >
                        (peekItem.events[0] as TSingleDefectiveEventWithoutStatus).defectivesInfo.round,
                  );
                  if (hasHigherRoundDefectives) {
                    return {
                      status: 'FAILURE',
                      error: 'HIGHER_ROUND_AVAILABLE',
                    };
                  }
                }
                return {
                  status: 'SUCCESS',
                  event: produce(bulkEvent as TForwardBulkEvent, (draft) => {
                    draft.events[0].eventInfo.v_id =
                      bctxKeyToDefectivesInfo[gId].futureValidEventList[
                        bctxKeyToDefectivesInfo[gId].futureValidEventList.length - 1
                      ].events[0].eventInfo.v_id;
                  }),
                };
              } else {
                return {
                  status: 'FAILURE',
                  error:
                    peekItem.events[0].actionType === 'REWORKED_FROM_DEFECTIVE' ? 'DEFECT_REWORKED' : 'DEFECT_REJECTED',
                };
              }
            }
          } else {
            return {
              status: 'FAILURE',
              error: bctxKeyToDefectivesInfo[gId].hasAnyServerErrorEvent ? 'SERVER_ERROR' : 'HISTORY_CHANGED',
            };
          }
        }
      }
    }
    return {
      status: 'FAILURE',
      error: 'NO_EVENTS_ADDED',
    };
  },

  getLastForwardPerPieceQcEventWithoutUndo(
    bulkEvents: TBulkEvent[],
    subjectId: string,
    shiftId: string,
    actionType: 'FTT' | 'REJECTED' | 'REWORKED_FROM_DEFECTIVE' | 'CHECK_IN',
    undoLimit: number,
  ): TLastEventResult {
    const filteredEvents = bulkEvents.filter((bulkEvent) => {
      return (
        this.hasEventHappenedInStationDetails(bulkEvent, subjectId, shiftId) &&
        (bulkEvent.type === 'FORWARD_BULK_EVENT' || bulkEvent.type === 'UNDO_BULK_EVENT') &&
        this.getRelatedActionTypesForUndo(actionType).some((relatedUndoActionType) => {
          return relatedUndoActionType === this.getActionTypeForBulkEvent(bulkEvent);
        })
      );
    });

    let undoEventsCount = 0;
    let forwardEventsCount = 0;
    const undoGroupIdSet = new Set<string>();
    for (let index = filteredEvents.length - 1; index >= 0 && undoEventsCount < undoLimit; index--) {
      const event = filteredEvents[index];
      if (event.type === 'FORWARD_BULK_EVENT') {
        if (
          event.backgroundMetadata.bulkEventStatus === 'SYNCED' ||
          event.backgroundMetadata.bulkEventStatus === 'YET_TO_BE_SYNCED' ||
          undoGroupIdSet.has(event.metadata.groupId)
        ) {
          forwardEventsCount++;
          if (forwardEventsCount > undoEventsCount) {
            return {
              status: 'SUCCESS',
              event: event,
            };
          }
        }
      } else if (event.type === 'UNDO_BULK_EVENT') {
        undoEventsCount++;
        undoGroupIdSet.add(event.undoMetadata.forwardEventGroupId);
      }
    }
    return {
      status: 'FAILURE',
      error: undoEventsCount === undoLimit ? 'LIMIT_REACHED' : 'NO_EVENTS_ADDED',
    };
  },

  getPerPieceQcLastEventWithLimitWithModifiedVId(
    bulkEvents: TBulkEvent[],
    subjectId: string,
    shiftId: string,
    actionType: TActionItemType,
    undoLimit: number,
    serverDefectivesDataUndo: TServerDefectivesDataUndo,
  ) {
    switch (actionType) {
      case 'FTT':
      case 'CHECK_IN':
      case 'REJECTED':
      case 'REWORKED_FROM_DEFECTIVE': {
        return this.getLastForwardPerPieceQcEventWithoutUndo(bulkEvents, subjectId, shiftId, actionType, undoLimit);
      }
      case 'DEFECTIVE': {
        return this.getLastForwardPerPieceDefectiveEvent(
          bulkEvents,
          subjectId,
          shiftId,
          undoLimit,
          serverDefectivesDataUndo,
        );
      }
    }
  },

  getLastEventWithLimitWithModifiedVId(
    bulkEvents: TBulkEvent[],
    subjectId: string,
    shiftId: string,
    actionType: TActionItemType,
    undoLimit: number,
    bctxKey: string | null,
  ) {
    switch (actionType) {
      case 'FTT':
      case 'CHECK_IN':
      case 'REJECTED':
      case 'REWORKED_FROM_DEFECTIVE': {
        return this.getLastForwardEventWithoutUndo(bulkEvents, subjectId, shiftId, actionType, undoLimit, bctxKey);
      }
      case 'DEFECTIVE': {
        return this.getLastForwardDefectiveEvent(bulkEvents, subjectId, shiftId, undoLimit, bctxKey);
      }
    }
  },

  generateRandomId(timestamp?: number) {
    if (!timestamp) timestamp = new Date().getTime();
    return timestamp + '_' + uuidv4();
  },

  generateGroupId(timestamp: number) {
    return this.generateRandomId(timestamp);
  },

  generateVId(timestamp: number) {
    return this.generateRandomId(timestamp);
  },

  generateUniqueEventId(timestamp: number) {
    return this.generateRandomId(timestamp);
  },

  getYetToBeSyncedBulkEventMetadata(
    location: TEventLocation,
    stationDetails: TEventStationDetails,
    eventTime: number,
  ): TBulkEvent['metadata'] {
    const groupId = this.generateGroupId(eventTime);
    return {
      eventTime: eventTime,
      groupId,
      location,
      stationDetails,
    };
  },

  getYetToBeSyncedEventCommonDetails(
    bctxDetails: TEventBctxDetails,
    eventTime: number,
    linked_v_id?: string,
  ): TEventCommonDetails {
    const v_id = this.generateVId(eventTime);
    return {
      v_id,
      bctxDetails,
      eventTime,
      linked_v_id,
    };
  },

  getYetToBeSyncedBctxChangeEventCommonDetails(
    oldBctxItemListWithoutSize: TBctxItemWithoutSize[],
    newBctxItemListWithoutSize: TBctxItemWithoutSize[],
    eventTime: number,
    sizeInfo: TBctxChangeEventSizeInfo,
  ): TBctxChangeEventWithoutStatus['events'][number] {
    const v_id = this.generateVId(eventTime);
    return {
      type: 'BCTX_CHANGE_EVENT',
      actionType: 'BCTX_CHANGE_EVENT',
      eventInfo: {
        v_id,
        newBctxItemListWithoutSize: newBctxItemListWithoutSize,
        oldBctxItemListWithoutSize,
        newSize: sizeInfo.newSize,
        oldSize: sizeInfo.oldSize,
        eventTime,
      },
    };
  },

  getBucketIdFromUniqueEventId(commitId: string): TBucketId {
    return `BUCKET_ID_${commitId}`;
  },

  isBulkEventsValidForAddition(bulkEvents: TBulkEventWithoutStatus[]) {
    return bulkEvents.every((event) => event.events.length > 0);
  },

  getYetToBeSyncedMemberAdditionEventCommonDetails(
    memberAdditionInfo: TMemberAdditionInfo,
    bctxItemsWithoutSize: TBctxItemWithoutSize[],
    eventTime: number,
    size?: string,
  ): TMemberAdditionEventWithoutStatus['events'][0] {
    const v_id = this.generateVId(eventTime);
    return {
      eventInfo: {
        v_id: v_id,
        memberAdditionInfo,
        newBctxItemListWithoutSize: bctxItemsWithoutSize,
        eventTime,
        newSize: size,
      },
      type: 'MEMBER_ADDITION_EVENT',
      actionType: 'MEMBER_ADDITION_EVENT',
    };
  },

  getYetToBeSyncedRoamingQcEventCommonDetails(
    audit: TAuditDTOModel,
    eventTime: number,
  ): TRoamingQcEventWithoutStatus['events'][0] {
    const v_id = this.generateVId(eventTime);
    return {
      eventInfo: {
        v_id: v_id,
        auditDetails: audit,
        eventTime,
      },
      type: 'ROAMING_QC_EVENT',
      actionType: 'ROAMING_QC_EVENT',
    };
  },

  getAqlEventCommonDetails(audit: TSingleAuditDetail, eventTime: number): TAqlEventWithoutStatus['events'][0] {
    const v_id = this.generateVId(eventTime);
    return {
      eventInfo: {
        v_id: v_id,
        auditDetails: audit,
        eventTime,
      },
      type: 'AQL_EVENT',
      actionType: 'AQL_EVENT',
    };
  },

  isActionRelatedToDefectives(actionType: TSingleCountEvent['actionType']) {
    switch (actionType) {
      case 'DEFECTIVE':
      case 'REJECTED_FROM_DEFECTIVE':
      case 'REWORKED_FROM_DEFECTIVE':
      case 'UNDO_DEFECTIVE':
      case 'UNDO_REJECTED_FROM_DEFECTIVE':
      case 'UNDO_REWORKED_FROM_DEFECTIVE':
        return true;
      default:
        return false;
    }
  },

  hasEventHappenedInStationDetails(bulkEvent: TBulkEvent, station: string, shift: string) {
    return (
      bulkEvent.metadata.stationDetails.shift.id === shift &&
      bulkEvent.metadata.stationDetails.subject.subject === station
    );
  },

  getValidAndInvalidDefectivesInfo(
    shiftId: string,
    stationId: string,
    bulkEvents: TBulkEvent[],
    bctxKey: string | null,
  ): TValidAndInvalidDefectivesInfo {
    const filteredEvents: TDefectiveReleatedEvent[] = [];
    bulkEvents.forEach((bulkEvent) => {
      if (
        this.hasEventHappenedInStationDetails(bulkEvent, stationId, shiftId) &&
        (bulkEvent.type === 'FORWARD_BULK_EVENT' || bulkEvent.type === 'UNDO_BULK_EVENT')
      ) {
        bulkEvent.events.forEach((event) => {
          if (
            (!bctxKey || event.eventInfo.bctxDetails.bctxKey === bctxKey) &&
            this.isActionRelatedToDefectives(event.actionType)
          ) {
            filteredEvents.push(event as TDefectiveReleatedEvent);
          }
        });
      }
    });
    return Object.entries(_.groupBy(filteredEvents, (event) => event.defectivesInfo.id)).reduce((acc, curr) => {
      const gId = curr[0];
      const eventList = curr[1];
      eventList.sort((a, b) => a.eventInfo.eventTime - b.eventInfo.eventTime);
      if (eventList.some((event) => event.eventBackgroundMetadata.status === 'SERVER_ERROR')) {
        acc[gId] = {
          eventList,
          futureValidEventList: [],
          hasAnyServerErrorEvent: true,
          failedEventVIds: new Set<string>(),
        };
      } else {
        const validEvents = [] as TDefectiveReleatedEvent[];
        const failedEventVIds = new Set<string>();
        eventList.forEach((event) => {
          if (event.eventBackgroundMetadata.status === 'VALIDATION_ERROR') failedEventVIds.add(event.eventInfo.v_id);
          else validEvents.push(event);
        });
        const futureValidEvents = [] as TDefectiveReleatedEvent[];
        validEvents.forEach((event) => {
          if (event.eventInfo.linked_v_id && failedEventVIds.has(event.eventInfo.linked_v_id)) {
            failedEventVIds.add(event.eventInfo.v_id);
          } else futureValidEvents.push(event);
        });
        acc[gId] = {
          futureValidEventList: futureValidEvents,
          eventList: eventList,
          hasAnyServerErrorEvent: false,
          failedEventVIds,
        };
      }
      return acc;
    }, {} as TValidAndInvalidDefectivesInfo);
  },

  getValidAndInvalidPerPieceEventsInfo(bulkEvents: TBulkEvent[]): TValidAndInvalidPerPieceEventsInfo {
    const filteredEvents: TBulkCountEvent[] = [];
    bulkEvents.forEach((bulkEvent) => {
      if (bulkEvent.type === 'FORWARD_BULK_EVENT' || bulkEvent.type === 'UNDO_BULK_EVENT') {
        filteredEvents.push(bulkEvent);
      }
    });
    return Object.entries(_.groupBy(filteredEvents, (event) => event.events[0].eventInfo.bctxDetails.bctxKey)).reduce(
      (acc, curr) => {
        const bctxKey = curr[0];
        const eventList = curr[1];
        eventList.sort((a, b) => a.events[0].eventInfo.eventTime - b.events[0].eventInfo.eventTime);
        if (eventList.some((event) => event.events[0].eventBackgroundMetadata.status === 'SERVER_ERROR')) {
          acc[bctxKey] = {
            eventList,
            futureValidEventList: [],
            hasAnyServerErrorEvent: true,
            failedEventVIds: new Set<string>(),
          };
        } else {
          const validEvents = [] as TBulkCountEvent[];
          const failedEventVIds = new Set<string>();
          eventList.forEach((event) => {
            if (event.events[0].eventBackgroundMetadata.status === 'VALIDATION_ERROR')
              failedEventVIds.add(event.events[0].eventInfo.v_id);
            else validEvents.push(event);
          });
          const futureValidEvents = [] as TBulkCountEvent[];
          validEvents.forEach((event) => {
            if (event.events[0].eventInfo.linked_v_id && failedEventVIds.has(event.events[0].eventInfo.linked_v_id)) {
              failedEventVIds.add(event.events[0].eventInfo.v_id);
            } else futureValidEvents.push(event);
          });
          acc[bctxKey] = {
            futureValidEventList: futureValidEvents,
            eventList: eventList,
            hasAnyServerErrorEvent: false,
            failedEventVIds,
          };
        }
        return acc;
      },
      {} as TValidAndInvalidPerPieceEventsInfo,
    );
  },

  getDefectivesFromEventsArray(
    shiftId: string,
    stationId: string,
    bulkEvents: TBulkEvent[],
    lineWiseServerDefectives: TServerDefectivesDB['dailyCache']['lineWiseServerDefectives'],
    pastDaysDefectives: TPastDaysDefectivesInfo,
    bctxKey: string | null,
  ): TDefectiveInfoWithLinkedVId[] {
    let serverDefectives =
      lineWiseServerDefectives[stationId] && lineWiseServerDefectives[stationId].shiftWiseServerDefectives[shiftId]
        ? lineWiseServerDefectives[stationId].shiftWiseServerDefectives[shiftId]
        : [];
    serverDefectives = serverDefectives.filter(
      (defective) => !bctxKey || defective.eventInfo.bctxDetails.bctxKey === bctxKey,
    );
    const defectiveEvents: TDefectiveInfoWithLinkedVId[] = [];
    const gIdToIncreasingRoundsEventsList = this.getValidAndInvalidDefectivesInfo(
      shiftId,
      stationId,
      bulkEvents,
      bctxKey,
    );
    const gIdToIncreasingRoundsServerDefectives = Object.entries(
      _.groupBy(serverDefectives, (defective) => defective.defectivesInfo.id),
    ).reduce((acc, curr) => {
      const gId = curr[0];
      const serverList = curr[1];
      serverList.sort((a, b) => a.defectivesInfo.round - b.defectivesInfo.round);
      acc[gId] = serverList;
      return acc;
    }, {} as Record<string, TDefectiveFromServer[]>);

    Object.entries(gIdToIncreasingRoundsEventsList).forEach(([gId, gIdToDefectivesInfo]) => {
      if (!gIdToDefectivesInfo.hasAnyServerErrorEvent) {
        const futureValidEventList = gIdToDefectivesInfo.futureValidEventList;
        let lastDefectiveNotAddedInClient: TDefectiveFromServer | undefined;
        if (
          futureValidEventList.length &&
          (futureValidEventList[0].defectivesInfo.round > 1 ||
            futureValidEventList[0].actionType === 'REJECTED_FROM_DEFECTIVE' ||
            futureValidEventList[0].actionType === 'REWORKED_FROM_DEFECTIVE') &&
          gIdToIncreasingRoundsServerDefectives[gId]
        ) {
          const roundToCheck =
            futureValidEventList[0].actionType === 'REJECTED_FROM_DEFECTIVE' ||
            futureValidEventList[0].actionType === 'REWORKED_FROM_DEFECTIVE'
              ? futureValidEventList[0].defectivesInfo.round
              : futureValidEventList[0].defectivesInfo.round - 1;
          const serverDefectiveList = gIdToIncreasingRoundsServerDefectives[gId];
          for (let index = serverDefectiveList.length - 1; index >= 0; index--) {
            if (serverDefectiveList[index].defectivesInfo.round === roundToCheck) {
              lastDefectiveNotAddedInClient = serverDefectiveList[index];
              break;
            }
          }
        }

        const remainingEvent = EventUtil.getLastEventRemaining(
          futureValidEventList.map((event) => {
            return {
              actionType: event.actionType,
              eventInfo: event,
            };
          }),
        );
        if (remainingEvent) {
          const peekItem = remainingEvent.eventInfo;
          if (peekItem.actionType === 'DEFECTIVE')
            defectiveEvents.push({
              event: peekItem,
              linked_v_id: futureValidEventList[futureValidEventList.length - 1].eventInfo.v_id,
            });
        } else if (lastDefectiveNotAddedInClient) {
          defectiveEvents.push({
            event: lastDefectiveNotAddedInClient,
            linked_v_id: undefined,
          });
        }
      }
    });
    Object.entries(gIdToIncreasingRoundsServerDefectives).forEach(([gId, eventsList]) => {
      if (
        !gIdToIncreasingRoundsEventsList[gId] ||
        (gIdToIncreasingRoundsEventsList[gId].futureValidEventList.length === 0 &&
          !gIdToIncreasingRoundsEventsList[gId].hasAnyServerErrorEvent)
      ) {
        const lastServerDefective = {
          event: eventsList[eventsList.length - 1],
          linked_v_id: undefined,
        };
        if (!pastDaysDefectives[gId] || pastDaysDefectives[gId].length === 0) {
          defectiveEvents.push(lastServerDefective);
        } else {
          //gIdToIncreasingRoundsServerDefectives this is only populated when all past defective events status is resolved.
          const defectiveInfo = EventUtil.getPastDefectiveStatus(pastDaysDefectives[gId]);
          if (defectiveInfo.hasServerErrorInPastEvents) {
            defectiveEvents.push(lastServerDefective);
          } else if (defectiveInfo.remainingEvent) {
            if (
              defectiveInfo.remainingEvent.eventType === 'DEFECTIVE' &&
              eventsList[eventsList.length - 1].defectivesInfo.round === defectiveInfo.remainingEvent.round
            ) {
              defectiveEvents.push(lastServerDefective);
            }
          } else if (defectiveInfo.firstEventInfo) {
            if (defectiveInfo.firstEventInfo.eventType === 'DEFECTIVE') {
              if (eventsList[eventsList.length - 1].defectivesInfo.round === defectiveInfo.firstEventInfo.round - 1) {
                defectiveEvents.push(lastServerDefective);
              }
            } else if (eventsList[eventsList.length - 1].defectivesInfo.round === defectiveInfo.firstEventInfo.round) {
              defectiveEvents.push(lastServerDefective);
            }
          } else defectiveEvents.push(lastServerDefective);
        }
      }
    });
    return defectiveEvents.sort((a, b) => {
      return -a.event.eventInfo.eventTime + b.event.eventInfo.eventTime;
    });
  },

  getPerPieceDefectivesFromEventsArray(
    bulkEvents: TBulkEvent[],
    serverDefectivesStoreDailyCache: TServerDefectivesDB['dailyCache'],
  ): TPerPieceDefectiveInfoWithLinkedVId[] {
    const defectiveEvents: TPerPieceDefectiveInfoWithLinkedVId[] = [];
    const groupedServerDefectives: Record<string, TDefectiveFromServer[]> = {};
    const bctxKeyToIncreasingRoundsEventsList = this.getValidAndInvalidPerPieceEventsInfo(bulkEvents);
    const lineWiseServerDefectives: TServerDefectivesDB['dailyCache']['lineWiseServerDefectives'] =
      serverDefectivesStoreDailyCache.lineWiseServerDefectives;

    //Grouping all the server-defectives across all stations and shifts(to be added)
    Object.entries(lineWiseServerDefectives).forEach(([_, shiftWiseServerDefectives]) => {
      Object.entries(shiftWiseServerDefectives.shiftWiseServerDefectives).forEach(([_, serverDefectives]) => {
        serverDefectives.forEach((serverDefective) => {
          if (!groupedServerDefectives[serverDefective.eventInfo.bctxDetails.bctxKey]) {
            groupedServerDefectives[serverDefective.eventInfo.bctxDetails.bctxKey] = [];
          }
          groupedServerDefectives[serverDefective.eventInfo.bctxDetails.bctxKey].push(serverDefective);
        });
      });
    });
    const bctxKeyToIncreasingRoundsServerDefectives = Object.entries(groupedServerDefectives).reduce((acc, curr) => {
      const gId = curr[0];
      const serverList = curr[1];
      serverList.sort((a, b) => a.defectivesInfo.round - b.defectivesInfo.round);
      acc[gId] = serverList;
      return acc;
    }, {} as Record<string, TDefectiveFromServer[]>);

    const defectiveActionTypes = EventUtil.getPerPieceQcActionTypes().defectiveActionTypes;
    //Getting the defectives from the events stored
    Object.entries(bctxKeyToIncreasingRoundsEventsList).forEach(([bctxKey, bctxKeyToDefectivesInfo]) => {
      if (!bctxKeyToDefectivesInfo.hasAnyServerErrorEvent) {
        let lastDefectiveNotAddedInClient: TDefectiveFromServer | undefined;
        const futureValidEventList = bctxKeyToDefectivesInfo.futureValidEventList;
        if (
          futureValidEventList.length &&
          defectiveActionTypes.some((actionType) => actionType === futureValidEventList[0].events[0].actionType)
        ) {
          const defectiveRelatedEvent = futureValidEventList[0].events[0] as TDefectiveReleatedEvent;
          if (
            (defectiveRelatedEvent.defectivesInfo.round > 1 ||
              defectiveRelatedEvent.actionType === 'REJECTED_FROM_DEFECTIVE' ||
              defectiveRelatedEvent.actionType === 'REWORKED_FROM_DEFECTIVE') &&
            bctxKeyToIncreasingRoundsServerDefectives[bctxKey]
          ) {
            const roundToCheck =
              defectiveRelatedEvent.actionType === 'REJECTED_FROM_DEFECTIVE' ||
              defectiveRelatedEvent.actionType === 'REWORKED_FROM_DEFECTIVE'
                ? defectiveRelatedEvent.defectivesInfo.round
                : defectiveRelatedEvent.defectivesInfo.round - 1;
            const serverDefectiveList = bctxKeyToIncreasingRoundsServerDefectives[bctxKey];
            for (let index = serverDefectiveList.length - 1; index >= 0; index--) {
              if (serverDefectiveList[index].defectivesInfo.round === roundToCheck) {
                lastDefectiveNotAddedInClient = serverDefectiveList[index];
                break;
              }
            }
          }
        }
        const remainingEvent = EventUtil.getLastEventRemaining(
          futureValidEventList.map((event) => {
            return {
              actionType: event.events[0].actionType,
              eventInfo: event,
            };
          }),
        );
        if (remainingEvent) {
          if (remainingEvent.actionType === 'DEFECTIVE') {
            const lastEventTimeOfLocalEvents =
              futureValidEventList[futureValidEventList.length - 1].events[0].eventInfo.eventTime;
            const lastServerSyncTime = serverDefectivesStoreDailyCache.lastSyncTime;
            let addLocalEvents = true;
            let higherRoundServerDefective: TDefectiveFromServer | undefined = undefined;

            if (lastServerSyncTime > lastEventTimeOfLocalEvents) {
              const defectiveRemainingEvent = remainingEvent.eventInfo.events[0] as TDefectiveReleatedEvent;
              const serverDefectiveList = bctxKeyToIncreasingRoundsServerDefectives[bctxKey];
              if (serverDefectiveList && serverDefectiveList.length > 0) {
                const latestServerDefective = serverDefectiveList[serverDefectiveList.length - 1];
                if (latestServerDefective.defectivesInfo.round > defectiveRemainingEvent.defectivesInfo.round) {
                  addLocalEvents = false;
                  higherRoundServerDefective = latestServerDefective;
                }
              }
            }

            if (addLocalEvents) {
              defectiveEvents.push({
                eventInfo: { type: 'USER_EVENT', event: remainingEvent.eventInfo },
                linked_v_id: remainingEvent
                  ? futureValidEventList[futureValidEventList.length - 1].events[0].eventInfo.v_id
                  : undefined,
              });
            } else {
              defectiveEvents.push({
                eventInfo: {
                  type: 'SERVER_DEFECTIVE',
                  event: higherRoundServerDefective as TDefectiveFromServer,
                },
                linked_v_id: undefined,
              });
            }
          }
        } else if (lastDefectiveNotAddedInClient) {
          defectiveEvents.push({
            eventInfo: {
              type: 'SERVER_DEFECTIVE',
              event: lastDefectiveNotAddedInClient,
            },
            linked_v_id: undefined,
          });
        }
      }
    });

    Object.entries(bctxKeyToIncreasingRoundsServerDefectives).forEach(([gId, eventsList]) => {
      if (
        !bctxKeyToIncreasingRoundsEventsList[gId] ||
        bctxKeyToIncreasingRoundsEventsList[gId].futureValidEventList.length === 0
      ) {
        const lastServerDefective: TPerPieceDefectiveInfoWithLinkedVId = {
          eventInfo: {
            type: 'SERVER_DEFECTIVE',
            event: eventsList[eventsList.length - 1],
          },
          linked_v_id: undefined,
        };
        defectiveEvents.push(lastServerDefective);
      }
    });

    return defectiveEvents.sort((a, b) => {
      const aTime =
        a.eventInfo.type === 'USER_EVENT'
          ? a.eventInfo.event.events[0].eventInfo.eventTime
          : a.eventInfo.event.eventInfo.eventTime;
      const bTime =
        b.eventInfo.type === 'USER_EVENT'
          ? b.eventInfo.event.events[0].eventInfo.eventTime
          : b.eventInfo.event.eventInfo.eventTime;
      return -aTime + bTime;
    });
  },
  //This should be only called after all past-defectives status is resolved, otherwise we may get run-time error/incorrect results
  getPastDefectiveStatus(pastDefectives: TPastDaysDefective[]) {
    const filtedPastDefectives = pastDefectives.filter((defective) => defective.status === 'SYNCED_WITH_SUCCESS');
    if (pastDefectives.find((defectiveInfo) => defectiveInfo.status === 'SERVER_ERROR')) {
      return {
        hasServerErrorInPastEvents: true,
        remainingEvent: null,
        firstEventInfo: null,
      };
    }
    const remainingEvent = EventUtil.getLastEventRemaining(
      filtedPastDefectives.map((defective) => {
        return {
          actionType: defective.eventType,
          eventInfo: defective,
        };
      }),
    );
    return {
      hasServerErrorInPastEvents: false,
      remainingEvent: remainingEvent ? remainingEvent.eventInfo : null,
      firstEventInfo: filtedPastDefectives.length ? filtedPastDefectives[0] : null,
    };
  },

  getValidEventsFromLinkedEvents(events: TBulkCountEvent[]) {
    const failedEventIds = new Set<string>();
    events.forEach((event) => {
      if (
        (event.events[0].eventInfo.linked_v_id && failedEventIds.has(event.events[0].eventInfo.linked_v_id)) ||
        event.events[0].eventBackgroundMetadata.status === 'VALIDATION_ERROR'
      ) {
        failedEventIds.add(event.events[0].eventInfo.v_id);
      }
    });
    return events.filter((event) => {
      return !failedEventIds.has(event.events[0].eventInfo.v_id);
    });
  },

  getDelayedEventsBorderTime(delayedEventsSLAInDays: number, cacheResetTime: number) {
    const currentTime = new Date().getTime();
    const delayedBorder =
      new Date(currentTime).setHours(0, 0, 0, 0) + cacheResetTime <= currentTime
        ? moment(currentTime)
            .subtract(delayedEventsSLAInDays - 1, 'days')
            .valueOf()
        : moment(currentTime).subtract(delayedEventsSLAInDays, 'days').valueOf();
    return delayedBorder;
  },

  getNonDelayedEvents(delayedEventsSLAInDays: number, bulkEvents: TBulkEvent[], cacheResetTime: number) {
    const delayedBorder = this.getDelayedEventsBorderTime(delayedEventsSLAInDays, cacheResetTime);
    return bulkEvents.filter((event) => event.metadata.eventTime >= delayedBorder);
  },
  getEventsWithinDelayWipUpdatesRange(
    pastDaysBackgroundEventsSyncInfo: TPastDaysBackgroundEventsSyncInfo,
    delayWipUpdatesByMin: number,
  ) {
    const currentTime = Date.now();
    const delayMinutesInMs = delayWipUpdatesByMin * 60 * 1000;

    return produce(pastDaysBackgroundEventsSyncInfo, (draft) => {
      Object.keys(draft).forEach((bctxKey) => {
        const syncTime = draft[bctxKey].syncTime;

        if (currentTime - syncTime > delayMinutesInMs) {
          delete draft[bctxKey]; // Remove outdated keys immutably
        }
      });
    });
  },
  updateBulkQcPastDefectivesStatus(pastDaysDefectives: TPastDaysDefectivesInfo, bulkEvents: TBulkEvent[]) {
    return produce(pastDaysDefectives, (draft) => {
      bulkEvents.forEach((bulkEvent) => {
        bulkEvent.events.forEach((event) => {
          if (
            event.actionType === 'DEFECTIVE' ||
            event.actionType === 'UNDO_DEFECTIVE' ||
            event.actionType === 'REJECTED_FROM_DEFECTIVE' ||
            event.actionType === 'UNDO_REJECTED_FROM_DEFECTIVE' ||
            event.actionType === 'REWORKED_FROM_DEFECTIVE' ||
            event.actionType === 'UNDO_REWORKED_FROM_DEFECTIVE'
          ) {
            const index = (draft[event.defectivesInfo.id] || []).findIndex(
              (defectiveInfo) => defectiveInfo.v_id === event.eventInfo.v_id,
            );
            if (index > -1) {
              draft[event.defectivesInfo.id][index] = {
                eventTime: event.eventInfo.eventTime,
                v_id: event.eventInfo.v_id,
                status: event.eventBackgroundMetadata.status,
                eventType: event.actionType,
                syncedTime: bulkEvent.backgroundMetadata.syncedTime,
                round: event.defectivesInfo.round,
              };
            }
          }
        });
      });
    });
  },

  updatePastDaysBackgroundEventsSyncInfo(
    pastDaysBackgroundEventsSyncInfo: TPastDaysBackgroundEventsSyncInfo,
    bulkEvents: TBulkEvent[],
  ) {
    return produce(pastDaysBackgroundEventsSyncInfo, (draft) => {
      bulkEvents.forEach((bulkEvent) => {
        bulkEvent.events.forEach((event) => {
          if (event.type === 'FORWARD_EVENT' || event.type === 'UNDO_EVENT') {
            const bctxKey = event.eventInfo.bctxDetails.bctxKey;
            if (bctxKey && bulkEvent.backgroundMetadata.syncedTime) {
              draft[bctxKey] = {
                syncTime: bulkEvent.backgroundMetadata.syncedTime,
              };
            }
          }
        });
      });
    });
  },

  getPerPieceQcActionTypes() {
    const defectiveActionTypes = [
      'DEFECTIVE',
      'UNDO_DEFECTIVE',
      'REJECTED_FROM_DEFECTIVE',
      'UNDO_REJECTED_FROM_DEFECTIVE',
      'REWORKED_FROM_DEFECTIVE',
      'UNDO_REWORKED_FROM_DEFECTIVE',
    ];
    const validActionTypes = ['FTT', 'UNDO_FTT', 'REJECTED', 'UNDO_REJECTED', ...defectiveActionTypes];
    return {
      validActionTypes,
      defectiveActionTypes,
    };
  },

  flushBulkQcPastDaysDefectivesInfo(
    pastDaysDefectives: TPastDaysDefectivesInfo,
    delayedEventsSLAInDays: number,
    cacheResetTime: number,
  ) {
    const delayedBorder = this.getDelayedEventsBorderTime(delayedEventsSLAInDays, cacheResetTime);
    const toBeRemovedGIds: string[] = [];
    Object.entries(pastDaysDefectives).forEach(([gid, defectives]) => {
      const len = defectives.length;
      if (len === 0) toBeRemovedGIds.push(gid);
      else if (defectives[len - 1].eventTime < delayedBorder) toBeRemovedGIds.push(gid);
      else if (defectives[len - 1].status !== 'YET_TO_BE_SYNCED') {
        const time = defectives[len - 1].syncedTime;
        if (time && new Date().getTime() > time + 18000000) {
          toBeRemovedGIds.push(gid);
        }
      }
    });
    return produce(pastDaysDefectives, (draft) => {
      toBeRemovedGIds.forEach((gid) => {
        delete draft[gid];
      });
    });
  },

  getFormatedDateFromDateTime: (datetime: number) => {
    const locale = LOCAL_STORAGE_UTILS.retrieveData('locale') as TSupportedLanguages; // it won't be null in any case since we are setting english as default from app-shell
    const date = new Date(datetime);
    return date.toLocaleDateString([LocalisationUtils.getLocaleForDateStringFromSelectedLanguage(locale), 'en'], {
      // 2nd value 'en' as fallback if some language is not supported
      day: 'numeric',
      month: 'long',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
  },

  updatePastDaySyncedEventsDB(resBulkEvents: TActivityLogEvent[], backupDB: TPastDaySyncedEventsDB) {
    return produce(backupDB, (draft) => {
      resBulkEvents.forEach((resEvent) => {
        const index = draft.listOfPastDaysEventsWhichAreSynced.findIndex(
          (event) => event.backgroundMetadata.groupId === resEvent.backgroundMetadata.groupId,
        );
        if (index !== -1) {
          draft.listOfPastDaysEventsWhichAreSynced[index] = resEvent;
        }
      });
    });
  },

  updateBgDBEventsList(resBulkEvents: TBulkEvent[], TotalBulkEvents: TBulkEvent[]) {
    return produce(TotalBulkEvents, (draft) => {
      resBulkEvents.forEach((resEvent) => {
        const index = draft.findIndex((bulkEvent) => bulkEvent.metadata.groupId === resEvent.metadata.groupId);

        if (index !== -1) {
          draft[index] = resEvent;
        }
      });
    });
  },

  findMatchingBulkEventByVId(v_id: string, bulkEvents: TBulkEvent[]) {
    return bulkEvents.find((bulkEvent) =>
      bulkEvent.events.some((event) => event.eventBackgroundMetadata.v_id === v_id),
    );
  },

  updateEventIds(bulkEvents: TBulkEvent[], startingId: number) {
    let updatedNextEventId = startingId;
    const updatedBulkEvents = produce(bulkEvents, (draft) => {
      draft.forEach((bulkEvent) => {
        bulkEvent.events.forEach((event) => {
          event.eventBackgroundMetadata.eventId = updatedNextEventId++;
        });
      });
    });
    return { updatedBulkEvents, updatedNextEventId };
  },

  getFormatedDayFromDateTime(eventTime: number, dayStartTime: number): string {
    const dayInMillis = 24 * 60 * 60 * 1000;

    const todayStart = dayStartTime;
    const yesterdayStart = todayStart - dayInMillis;
    const dayBeforeYesterdayStart = yesterdayStart - dayInMillis;

    if (eventTime >= todayStart) {
      return 'TODAY';
    } else if (eventTime >= yesterdayStart && eventTime < todayStart) {
      return 'YESTERDAY';
    } else if (eventTime >= dayBeforeYesterdayStart && eventTime < yesterdayStart) {
      return 'DAY_BEFORE_YESTERDAY';
    } else {
      return 'OLDER';
    }
  },

  isCurrentTimeWithinSession(startTime: string, endTime: string, bufferMinutes: number): boolean {
    const now = new Date();
    // we are using string split because we are getting time in 24 hour format "HH:MM"
    const [startH, startM] = startTime.split(':').map(Number);
    const [endH, endM] = endTime.split(':').map(Number);

    const startDate = new Date(now);
    startDate.setHours(startH, startM, 0, 0);

    const endDate = new Date(now);
    endDate.setHours(endH, endM + bufferMinutes, 0, 0);

    // If the session crosses midnight
    if (endDate <= startDate) {
      // Move end time to next day
      endDate.setDate(endDate.getDate() + 1);
    }
    return now >= startDate && now < endDate;
  },
};
